define('TescoMobile_Checkout/js/item-discontinued',['uiComponent', 'ko', 'jquery', 'Magento_Ui/js/modal/alert', 'mage/translate', 'mage/url', 'Magento_Customer/js/customer-data'], function (Component, ko, $, alertModal, $t, urlBuilder, customerData) {
  'use strict';

  return Component.extend({
    quoteItems: ko.observableArray([]),
    initialize: function () {
      this._super();
      var self = this,
        cartData = customerData.get('cart'),
        customerCartData = cartData();
      this.getQuoteItems();
      $('body').on('get-quote-items', function () {
        var _customerCartData$ite;
        if (((_customerCartData$ite = customerCartData.items) === null || _customerCartData$ite === void 0 ? void 0 : _customerCartData$ite.length) > 0 && self.quoteItems().length > 0) {
          var founds = [];
          customerCartData.items.forEach(function (obj) {
            var found = self.quoteItems().find(item => item === obj.product_id);
            if (found === undefined) {
              founds.push(obj);
            }
          });
          if (founds.length > 0) {
            self.modalInit();
          }
        }
      });
    },
    modalInit: function () {
      alertModal({
        title: $t('Item no longer available'),
        content: $t('An item in your basket is no longer available. You need to update your cart.'),
        type: 'popup',
        modalClass: 'cart-item-no-longer',
        clickableOverlay: false,
        buttons: [{
          text: $t('Update My Basket'),
          class: 'action-primary action-dismiss',
          click: function (event) {
            this.closeModal(event);
          }
        }],
        closed: function () {
          var sections = ['cart'];
          customerData.invalidate(sections);
          customerData.reload(sections, true);
        }
      });
    },
    getQuoteItems: function () {
      var self = this;
      $.ajax({
        url: urlBuilder.build('checkout/cart/hasDiscontinuedItems'),
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function (result) {
          self.quoteItems(result.items);
          $('body').trigger('get-quote-items');
        }
      });
    }
  });
});

